module.exports = __webpack_public_path__ + "img/LoloMomo.45234e8a.png";